import medialabel from './medialabel.module'
export default medialabel
